import React from 'react';
import propTypes from 'prop-types';
import Text from '../../typography'
import {Grid, Box} from '@mui/material';
import styled from '@emotion/styled';
import RespImg from '../../ui/RespImg';
import {theme} from '../../../themes/default-theme';

const Container = styled.div`
  margin-top: 75px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  ${theme.breakpoints.up("md")} {
    display: flex;
  }
  ${theme.breakpoints.down("md")} {
    margin-top: 40px;
  }
  ${theme.breakpoints.down("sm")} {
    margin-top: 24px;
  }
`

const Logo = styled.div`
  ${theme.breakpoints.up("md")} {
    flex-grow: 1;
    display: inline-block;
    & {
      border-left: 1px solid ${theme.palette.middleGrey};
    }
    &:last-child {
      border-left: 1px solid ${theme.palette.middleGrey};
      border-right: 1px solid ${theme.palette.middleGrey};
    }
  }
  ${theme.breakpoints.down("sm")} {
    width: 100%;
    padding: 5px;
    & {
      border-bottom: 1px solid ${theme.palette.middleGrey};
    }
    &:last-child {
      border-top: none;
      border-bottom: none;
    }
  }
`

const LogoContainer = styled.div`
  max-width: 268px;
  margin-left: auto;
  margin-right: auto;
  ${theme.breakpoints.down("md")} {
    max-width: 140px;
  }
  ${theme.breakpoints.down("sm")} {
    max-width: 160px;
  }
`

const logoListingDefaultPropItems = [];

const LogoListing = ({title = null, items = logoListingDefaultPropItems, hTag}) => {
  return (
    <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} alignItems={'flex-start'}>
      <Grid size={12}>
        <Box px={2}>
          {title && <Text variant="h2" element={hTag ? hTag : 'h2'} size="large" colour="charcoal" uppercase={true} align="center">{title}</Text>}
          <Container>
            {items.map((item, index) => (
              <Logo key={index}>
                <LogoContainer>
                  {item.image &&
                    <RespImg 
                      {...item.image}
                    />
                  }
                  {item.alt || item.sizes &&
                    <RespImg 
                      {...item}
                    />
                  }
                </LogoContainer>
              </Logo>
            ))}
          </Container>
        </Box>
      </Grid>
    </Grid>
  );
}

LogoListing.propTypes = {
  title: propTypes.string,
  items: propTypes.array
}

export default LogoListing